export default /[a-zA-Z0-9]/;
